export default {
  name: 'fullScreen',
  data () {
    return {
      targetDom: null,
      viewHeight: null,
      isLandScape: null
    }
  },
  computed: {},
  watch: {
    viewHeight (aft, bef) {
      if (bef !== aft) this.setFullHeight()
    },
    isLandScape (state) {
      if (state) this.estimateViewHeight()
    }
  },
  created () {},
  mounted () {},
  methods: {
    estimateViewHeight () {
      this.isLandScape = window.innerHeight < window.innerWidth
      let [html] = [document.documentElement]
      let height = !this.isLandScape ? html.clientHeight : window.innerHeight
      this.viewHeight = height
    },
    setFullHeight () {
      document.documentElement.style.height = this.viewHeight + 'px'
    },
    setHeightFull () {
      document.body.classList.add('h-100')
      document.getElementById('app').className = 'd-flex flex-column h-100'
    },
    unSetFullHeight () {
      document.documentElement.removeAttribute('style')
      document.body.classList.remove('h-100')
      document.getElementById('app').className = ''
      this.targetDom = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/view/fullScreen.js